import ConfigurationUtils from '@/views/configuration/utils';
import { sleep } from '@/utils';
import { postRequests } from '@/service/requests';

export default class VQBGateway {
  static URL = 'https://api-production.visualquizbuilder.com';
  static async getQuizData() {
    const apiCred = {
      private: process.env.VQB_BROWSER_API_KEY,
      public: process.env.VQB_PUBLIC_API_KEY
    };

    const sessionId =
      ConfigurationUtils.getUrlPramByKey(`quiz_session`) ??
      localStorage.getItem('QuizSessionId');

    ConfigurationUtils.setUrlParam({
      key: 'quiz_session',
      value: sessionId
    });

    const config = {
      headers: {
        'Content-Type': 'application/json',
        ACCESSKEY: apiCred.public,
        Authorization: `Token ${apiCred.private}`
      }
    };

    const config1 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ACCESSKEY: apiCred.public,
        Authorization: `Token ${apiCred.private}`
      },
      body: JSON.stringify({})
    };

    let retries = 0;
    const maxRetries = 3;
    const retryDelay = 1000;

    while (retries < maxRetries) {
      try {
        let [response_full, response_with_tag] = await Promise.all([
          postRequests(
            `${VQBGateway.URL}/api/public/quiz_data/${sessionId}`,
            {},
            config
          ),
          postRequests(
            `${VQBGateway.URL}/api/public/quiz_data/${sessionId}?minimal=True`,
            {},
            config
          )
        ]);

        if (!response_full.status === 200) {
          const message = `[VQB] An error has occured: ${response_full.status}`;
          throw new Error(message);
        }
        if (!response_with_tag.status === 200) {
          const message = `[VQB_mini] An error has occured: ${response_with_tag.status}`;
          throw new Error(message);
        }

        const responseFullData = await response_full.data;
        const responseWithTagData = await response_with_tag.data;

        if (
          responseFullData &&
          responseFullData.quiz_session &&
          responseWithTagData &&
          responseWithTagData.quiz_session
        ) {
          return { responseFullData, responseWithTagData, sessionId };
        } else {
          retries++;
          console.log(`[VQB] Retry ${retries} ...`);
          await new Promise((resolve) => setTimeout(resolve, retryDelay));
        }
      } catch (error) {
        retries++;
        console.log(`[VQB] Retry ${retries} ...`);
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
    throw new Error(`Failed to fetch VQB data after ${maxRetries} retries`);
  }
  static async getFormattedQuizData() {
    try {
      await sleep(4000);

      const { responseFullData, responseWithTagData, sessionId } =
        await VQBGateway.getQuizData();

      if (!responseFullData.quiz_completed) {
        const message = `Please complete the quiz to get your result.`;
        throw new Error(message);
      }

      responseFullData['session_id'] = sessionId;
      responseFullData['quiz_responses_with_tag'] = JSON.parse(
        JSON.stringify(responseWithTagData.quiz_responses)
      );

      return {
        success: true,
        message: 'Using returned VQB session data for preparing input',
        data: responseFullData
      };
    } catch (error) {
      console.log(`Error when requesting VQB data, details see below...`);
      console.error(`Error when requesting VQB data`, error);
      return {
        success: false,
        message: `Cannot retrieve your quiz data, ${error.message}`,
        data: {}
      };
    }
  }
}
